;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.entity.show')
    .controller('EntityShowToolbarController', EntityShowToolbarController)

  EntityShowToolbarController.$inject = [
    // Angular
    '$state',

    // Services
    'SessionService', 'EntityService', 'DisplayService', 'SnackService', 'PreferencesService',

    // Resolve
    'entity'

  ]

  function EntityShowToolbarController (
    // Angular
    $state,

    // Services
    SessionService, EntityService, DisplayService, SnackService, PreferencesService,

    // Resolve
    entity

  ) {
    var self = this
    var ACCESSIBLES_TYPES = ['Individual', 'Organization', 'Agency']

    self.$onInit = () => {
      _.extend(self, {
        entity: entity,
        title: entity.label,
  
        isEntityHousing: isEntityHousing,
        isEntityPro: isEntityPro,
        isValidator: isValidator,
        createEntity: createEntity,
        init: init,
        archive: archive,
        requiredForExport: false
      })
    }

    function init () {
      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        self.requiredForExport = _.get(companyPrefs, 'enabledFeatures.self.requiredForExport');
      });
    }
    function archive () {
      DisplayService.confirmDeletion().then(function () {
        self.loading = true
        entity.archive().then(function () {
          SnackService.snack({
            text: 'Élément supprimé !',
            delay: 3000
          })
          $state.go('entity.list')
        })
      })
    }

    function isEntityHousing () {
      return _.capitalize(entity.getRealType()) === 'Housing'
    }

    function isEntityPro () {
      return entity.getRealType() === 'professional'
    }

    function isValidator () {
      return SessionService.isValidator() || SessionService.isAdmin()
    }

    function createEntity () {
      var index = _.indexOf(ACCESSIBLES_TYPES, _.capitalize(entity.getRealType()))
      var types = _.drop(ACCESSIBLES_TYPES, index + 1)
      EntityService.createEntity(self.entity, types, {allowChildren: true, from: 'sufa', entityAccountRequired: self.requiredForExport}).then(function (data) {
        $state.reload()
      })
    }
  }
})(window.angular, window._)
